import { api } from "@/lib/api";

// -- Catalog ---------------------------------------------------------------
export const paymentsCatalog = async () => (await api.get("/payments/catalog")).data;

// -- Founder subscription --------------------------------------------------
export const createCheckout = async (lookupKey) =>
  (await api.post("/payments/checkout", {
    lookup_key: lookupKey,
    origin_url: window.location.origin,
  })).data;

export const checkoutStatus = async (sessionId) =>
  (await api.get(`/payments/status/${encodeURIComponent(sessionId)}`)).data;

export const mySubscription = async () => (await api.get("/payments/subscription/me")).data;

export const cancelSubscription = async () =>
  (await api.post("/payments/subscription/cancel")).data;

// -- Mock checkout finalisation (mock mode only) ---------------------------
export const mockFinalize = async (sessionId, outcome) =>
  (await api.post("/payments/mock/finalize", { session_id: sessionId, outcome })).data;

export const mockSessionPublic = async (sessionId) =>
  (await api.get(`/payments/mock/session/${encodeURIComponent(sessionId)}`)).data;

// -- Connect Express onboarding --------------------------------------------
export const connectOnboardingLink = async () =>
  (await api.post("/payments/connect/onboarding-link", {
    origin_url: window.location.origin,
  })).data;

export const connectStatus = async () => (await api.get("/payments/connect/status")).data;

export const mockConnectComplete = async (accountId) =>
  (await api.post("/payments/connect/mock/complete", { account_id: accountId })).data;

export const mockConnectPublic = async (accountId) =>
  (await api.get(`/payments/connect/mock/public/${encodeURIComponent(accountId)}`)).data;

// -- Ledger ----------------------------------------------------------------
export const myLedger = async (page = 1, pageSize = 50) =>
  (await api.get(`/payments/ledger/me?page=${page}&page_size=${pageSize}`)).data;

export const adminLedger = async (status, page = 1, pageSize = 50) => {
  const q = new URLSearchParams();
  if (status) q.set("status", status);
  q.set("page", String(page));
  q.set("page_size", String(pageSize));
  return (await api.get(`/payments/admin/ledger?${q.toString()}`)).data;
};

// -- Payout runs (admin) ---------------------------------------------------
export const startPayoutRun = async () =>
  (await api.post("/payments/admin/payout-runs")).data;

export const listPayoutRuns = async (limit = 20) =>
  (await api.get(`/payments/admin/payout-runs?limit=${limit}`)).data;

export const payoutRunTransfers = async (runId) =>
  (await api.get(`/payments/admin/payout-runs/${encodeURIComponent(runId)}/transfers`)).data;

// -- Helpers ---------------------------------------------------------------
export const formatCents = (cents, currency = "usd") => {
  const value = (cents || 0) / 100;
  const symbol = currency === "usd" ? "$" : "";
  return `${symbol}${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
